import { visibleAdminNavigationEntries, type AdminTab, type NavigationAccessInput, type NavigationLabelContext } from './navigationRegistry'

/** Shared by the existing sidebar and command adapter; this is display policy, not authority. */
export const adminNavigationForExperience = (context: NavigationAccessInput, isSimple: boolean) =>
  visibleAdminNavigationEntries(context).filter(entry => !isSimple || !['org-tree', 'skills', 'worklog'].includes(entry.key))

export function adminNavigationLabel(tab: AdminTab, fallback: string,
  { isSimple, t, explicitIndustry, label }: NavigationLabelContext & { isSimple: boolean }): string {
  if (isSimple) {
    if (tab === 'jobs') return t('Work / Post Work')
    if (tab === 'locations') return t('Worksites / Punch Areas')
    if (tab === 'relationships') return t('Workforce Partners')
    if (tab === 'users-access') return t('Supervisors & Access')
    if (tab === 'timesheets') return t('Review Worked Time')
    if (tab === 'payroll') return t('Prepare Payroll')
  }
  if (!explicitIndustry || !label) return fallback
  if (tab === 'workers') return label('workers')
  if (tab === 'jobs') return label('jobs')
  if (tab === 'locations') return `${label('locations')} & Geofences`
  if (tab === 'schedule') return `${label('shifts')} / Schedule`
  if (tab === 'timesheets') return `${label('timesheet')} / Approvals`
  if (tab === 'payroll') return `${label('payroll')} Export`
  return fallback
}
